export default __webpack_public_path__ + "static/media/bracers_of_vengeful_zeal.c41873b0.jpg";